import {
    GET_CATEGORY_LISTING,
    GET_CATEGORY_LISTING_SUCCESS,
    GET_CATEGORY_LISTING_FAIL,
    GET_CATEGORY_DETAILS,
    GET_CATEGORY_DETAILS_SUCCESS,
    GET_CATEGORY_DETAILS_FAIL,
    ADD_CATEGORY,
    ADD_CATEGORY_SUCCESS,
    ADD_CATEGORY_FAIL,
    UPDATE_CATEGORY,
    UPDATE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_FAIL,
    BULK_UPDATE_CATEGORY,
    BULK_UPDATE_CATEGORY_SUCCESS,
    BULK_UPDATE_CATEGORY_FAIL,
    DELETE_CATEGORY,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_FAIL,
    BULK_DELETE_CATEGORY,
    BULK_DELETE_CATEGORY_SUCCESS,
    BULK_DELETE_CATEGORY_FAIL,
    EXPORT_CATEGORY,
    EXPORT_CATEGORY_SUCCESS,
    EXPORT_CATEGORY_FAIL,
    RESET_CATEGORY_STATE,
    RESET_CATEGORY_ATTACHMENT_STATE,
} from "./actionTypes";

export const getCategoryListing = (payload) => ({
    type: GET_CATEGORY_LISTING,
    payload: payload
});

export const getCategoryListingSuccess = categories => ({
    type: GET_CATEGORY_LISTING_SUCCESS,
    payload: categories,
});

export const getCategoryListingFail = error => ({
    type: GET_CATEGORY_LISTING_FAIL,
    payload: error,
});

export const getCategoryDetails = categoryId => ({
    type: GET_CATEGORY_DETAILS,
    payload: categoryId,
});

export const getCategoryDetailsSuccess = category => ({
    type: GET_CATEGORY_DETAILS_SUCCESS,
    payload: category,
});

export const getCategoryDetailsFail = error => ({
    type: GET_CATEGORY_DETAILS_FAIL,
    payload: error,
});

export const createCategory = category => ({
    type: ADD_CATEGORY,
    payload: category,
});

export const createCategorySuccess = category => ({
    type: ADD_CATEGORY_SUCCESS,
    payload: category,
});

export const createCategoryFail = error => ({
    type: ADD_CATEGORY_FAIL,
    payload: error,
});

export const updateCategory = category => ({
    type: UPDATE_CATEGORY,
    payload: category,
});

export const updateCategorySuccess = category => ({
    type: UPDATE_CATEGORY_SUCCESS,
    payload: category,
});

export const updateCategoryFail = error => ({
    type: UPDATE_CATEGORY_FAIL,
    payload: error,
});

export const bulkUpdateCategory = category => ({
    type: BULK_UPDATE_CATEGORY,
    payload: category,
});

export const bulkUpdateCategorySuccess = category => ({
    type: BULK_UPDATE_CATEGORY_SUCCESS,
    payload: category,
});

export const bulkUpdateCategoryFail = error => ({
    type: BULK_UPDATE_CATEGORY_FAIL,
    payload: error,
});

export const deleteCategory = categoryId => ({
    type: DELETE_CATEGORY,
    payload: categoryId,
});

export const deleteCategorySuccess = categoryId => ({
    type: DELETE_CATEGORY_SUCCESS,
    payload: categoryId,
});

export const deleteCategoryFail = error => ({
    type: DELETE_CATEGORY_FAIL,
    payload: error,
});

export const bulkDeleteCategory = categoryId => ({
    type: BULK_DELETE_CATEGORY,
    payload: categoryId,
});

export const bulkDeleteCategorySuccess = categoryId => ({
    type: BULK_DELETE_CATEGORY_SUCCESS,
    payload: categoryId,
});

export const bulkDeleteCategoryFail = error => ({
    type: BULK_DELETE_CATEGORY_FAIL,
    payload: error,
});

export const exportCategory = (payload) => ({
    type: EXPORT_CATEGORY,
    payload: payload
});

export const exportCategorySuccess = data => ({
    type: EXPORT_CATEGORY_SUCCESS,
    payload: data,
});

export const exportCategoryFail = error => ({
    type: EXPORT_CATEGORY_FAIL,
    payload: error,
});

//reset
export const resetCategoryState = () => {
    return {
        type: RESET_CATEGORY_STATE,
    }
}
//reset attachment
export const resetCategoryAttachmentState = () => {
    return {
        type: RESET_CATEGORY_ATTACHMENT_STATE,
    }
}

